/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantSettingApiModel } from './tenantSettingApiModel';
import { UserSettingApiModel } from './userSettingApiModel';
import { AdminTenantSettingApiModel } from './adminTenantSettingApiModel';


export interface UserTenantSettingApiModel { 
    tenantSettings: Array<TenantSettingApiModel>;
    adminTenantSettings: Array<AdminTenantSettingApiModel>;
    userSettings: Array<UserSettingApiModel>;
}

